import React from 'react'
import { LegendLayer } from 'mbgl-components'

export default ({ symbol, color, lineColor, labels }) => {
    let symbolStyle
    let legendSymbol
    if (symbol === 'gradient') {
        symbolStyle = {
            background: `linear-gradient(to right, ${color.map(({ hex, position }) => `${hex} ${position}%`)})`
        }
        legendSymbol = (
            <div className="gradient-color-legend">
                <p className="gradient-label">{labels[0].name}</p>
                <div className="scale-wrapper">
                    <p className="min" aria-hidden="true">
                        {labels[0].lowLabel}
                    </p>
                    <div className="gradient" style={symbolStyle} />
                    <p className="max" aria-hidden="true">
                        {labels[0].highLabel}
                    </p>
                </div>
            </div>
        )
        return <div className="legend-element">{legendSymbol}</div>
    }
    if (symbol === 'rect-simple-hatch' || symbol === 'rect-crosshatch' || symbol === 'rect-solid') {
        symbolStyle = {
            height: '20px',
            width: '20px',
            border: `2px solid ${lineColor}`
        }
        if (symbol === 'rect-solid') {
            symbolStyle.backgroundColor = color
            legendSymbol = <div className="legend-symbol" style={symbolStyle} />
        } else if (symbol === 'rect-simple-hatch') {
            symbolStyle.background = `repeating-linear-gradient(135deg, transparent, transparent 3px, ${color} 3px, ${color} 4px)`
            legendSymbol = <div className="legend-symbol" style={symbolStyle} />
        } else {
            symbolStyle.background = `repeating-linear-gradient(135deg, transparent, transparent 3px, ${color} 3px, ${color} 4px)`
            symbolStyle.position = 'absolute'
            const crosshatch = {
                height: '20px',
                width: '20px',
                background: `repeating-linear-gradient(45deg, transparent, transparent 3px, ${color} 3px, ${color} 4px)`,
                border: `2px solid ${color}`
            }
            legendSymbol = (
                <div>
                    <div className="legend-symbol" style={symbolStyle} />
                    <div className="legend-symbol" style={crosshatch} />
                </div>
            )
        }
    } else {
        if (symbol === 'point') {
            symbolStyle = {
                backgroundColor: color,
                height: '10px',
                width: '10px',
                border: `1px solid ${lineColor}`,
                borderRadius: '50%'
            }
        } else if (symbol === 'line') {
            symbolStyle = {
                backgroundColor: color,
                border: 'none',
                width: '20px',
                height: '2px'
            }
        }
        legendSymbol = <div className="legend-symbol" style={symbolStyle} />
    }
    return (
        <div className="legend-element">
            {legendSymbol} <div className="legend-label">{labels}</div>
        </div>
    )
}
